/**
 * @file sidebar-filters.js
 */
(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.sidebarFilters = {
    attach: function (context, settings) {
      // Select all sidebar filter forms with class `sidebar-filters`
      $('.sidebar-filters', context).each(function () {
        const $sidebar = $(this);
        const sidebarId = $sidebar.attr('id') || 'defaultSidebarId';
        const storageKey = `openDetailsState_${sidebarId}`;
        let openDetailsArray = JSON.parse(sessionStorage.getItem(storageKey)) || [];

        // Function to update open details in the array
        function updateOpenDetailsArray() {
          openDetailsArray = []; // Reset the array

          $sidebar.find('details').each(function (index) {
            let $details = $(this);
            let $summary = $details.find('summary').first();

            if ($details.prop('open')) {
              openDetailsArray.push(index);
              $summary.attr('aria-expanded', 'true');
            } else {
              $summary.attr('aria-expanded', 'false');
            }
          });

          // Save the updated array to sessionStorage
          sessionStorage.setItem(storageKey, JSON.stringify(openDetailsArray));
        }

        // Function to restore open/closed state based on the stored indices
        function restoreOpenDetails() {
          if (openDetailsArray.length === 0) {
            // If no stored state, open all <details> elements by default
            $sidebar.find('details').each(function () {
              let $details = $(this);
              let $summary = $details.find('summary').first();
              $details.prop('open', true);
              $summary.attr('aria-expanded', 'true');
            });
          } else {
            // Restore the open/closed state based on stored data
            $sidebar.find('details').each(function (index) {
              let $details = $(this);
              let $summary = $details.find('summary').first();

              if (openDetailsArray.includes(index)) {
                $details.prop('open', true);
                $summary.attr('aria-expanded', 'true');
              } else {
                $details.prop('open', false);
                $summary.attr('aria-expanded', 'false');
              }
            });
          }
        }

        // Restore the state on initial load or after an AJAX update
        restoreOpenDetails();

        // Update the array and aria-expanded attribute whenever a details element is toggled
        $sidebar.find('details').on('toggle', function () {
          updateOpenDetailsArray();
        });
      });

      // Re-apply the behavior on AJAX updates
      $(document).ajaxComplete(function () {
        Drupal.behaviors.sidebarFilters.attach(document, drupalSettings);
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
